import { render, staticRenderFns } from "./TableReportYear.vue?vue&type=template&id=4090cd60&"
import script from "./TableReportYear.vue?vue&type=script&lang=js&"
export * from "./TableReportYear.vue?vue&type=script&lang=js&"
import style0 from "./TableReportYear.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/home/runner/work/myody_front/myody_front/components/link/Link.vue').default})
